import { useEffect, useState } from "react";
import { GlobeHemisphereEastIcon, SunHorizonIcon } from "@phosphor-icons/react";

const REGIONS = [
  { flag: "🇨🇳", name: "China", tz: "Asia/Shanghai" },
  { flag: "🇯🇵", name: "Japan", tz: "Asia/Tokyo" },
  { flag: "🇮🇳", name: "India", tz: "Asia/Kolkata" },
  { flag: "🇦🇪", name: "Dubai", tz: "Asia/Dubai" },
  { flag: "🇬🇧", name: "Great Britain", tz: "Europe/London" },
  { flag: "🇺🇸", name: "United States", tz: "America/New_York" },
];

const partsFor = (tz, now) => {
  const s = new Intl.DateTimeFormat("en-GB", { timeZone: tz, hour: "2-digit", minute: "2-digit", hourCycle: "h23" }).format(now);
  const [h, m] = s.split(":").map(Number);
  return { h, m, label: s };
};

// "Waking up" = local morning window 6:00–8:59, peak at 7am
const wakeState = (h) => (h >= 6 && h < 9 ? (h === 7 ? "peak" : "wake") : h >= 9 && h < 18 ? "day" : "night");

export const WorldClock = () => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="border border-white/10 bg-card" data-testid="world-clock">
      <div className="flex items-center gap-2 px-5 py-3 border-b border-white/10">
        <GlobeHemisphereEastIcon size={18} weight="fill" className="text-neon" />
        <span className="font-heading font-bold text-sm tracking-tight">WORLD CLOCK</span>
        <span className="text-[11px] font-mono text-muted-foreground">· who's waking up (volume waves)</span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 divide-x divide-y lg:divide-y-0 divide-white/5">
        {REGIONS.map((r) => {
          const { h, m, label } = partsFor(r.tz, now);
          const waking = wakeState(h);
          const isWake = waking === "wake" || waking === "peak";
          return (
            <div
              key={r.tz}
              data-testid={`clock-${r.name.replace(/\s+/g, "-").toLowerCase()}`}
              className={`px-4 py-3 flex flex-col gap-1 transition-colors ${isWake ? "bg-warn/[0.07]" : ""}`}
            >
              <div className="flex items-center gap-1.5">
                <span className="text-base leading-none">{r.flag}</span>
                <span className="text-[11px] text-muted-foreground truncate">{r.name}</span>
              </div>
              <div className="flex items-baseline gap-1">
                <span className={`font-mono font-bold text-lg tabular-nums ${isWake ? "text-warn" : "text-white"}`}>{label}</span>
                <span className="text-[10px] font-mono text-muted-foreground">{Number(m) >= 0 ? "" : ""}</span>
              </div>
              {isWake ? (
                <span className="flex items-center gap-1 text-[10px] font-mono text-warn">
                  <SunHorizonIcon size={12} weight="fill" /> {waking === "peak" ? "Waking up now" : "Waking up"}
                </span>
              ) : (
                <span className="text-[10px] font-mono text-muted-foreground/60">{waking === "day" ? "Active" : "Asleep"}</span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
